// import { FormControl, InputLabel, MenuItem, Select, TextField } from "@material-ui/core"
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import LibrarySearchIcon from "../../../../images/library-searchIcon.svg";
import CrossIcon from "../../../../images/clearTextIcon.svg";

import "./TextFields.scss";
import { useState } from "react";

export const TextFields = (props) => {
    const {disabled, label, defaultValue, className} = props;
    return (
        <TextField
            disabled={disabled}
            // id="filled-disabled"
            label={label}
            defaultValue={defaultValue}
            variant="filled"
            className={className}
        />
    )
}

export const DropDownField = (props) => {
    const {
        disabled, 
        label, 
        defaultValue, 
        className, 
        formControlClassName,
        formControlLabel,
        formControlLabelName,
        topic,
    } = props;
    return (
        <FormControl
            size="small"
            fullWidth
            className={formControlClassName}
            >
            <InputLabel
                // id="module-content-label-id"
                // id="demo-simple-select-label"
                className={formControlLabel}
            >
                {formControlLabelName}
            </InputLabel>
            <Select
                // labelId="demo-select-small"
                // id="demo-select-small"
            >
                {topic &&
                topic.length > 0 &&
                topic.map((item) => {
                    return (
                    <MenuItem value={item?.title} id={item.title} key={item.title}>
                        {item?.title}
                    </MenuItem>
                    );
                })}
            </Select>
        </FormControl>
    )
}

export const SearchTextField = ({searchfieldsHandler, searchHandler, searchText, cancelSearchField, handleEnterKeypress, placeholderName="Search by PDF Name"}) => {
    // const {
    // } = props;
    const [customPlaceholder, setCustomPlaceholder] = useState(true);

    const handleCustomPlaceholder = () => {
        // setCustomPlaceholder(false);
    }
    
    return (
        <div className="d-flex g-0 module-content-search-field">
            <img
            alt="search"
            src={LibrarySearchIcon}
            className={"module-content-search-icon"}
            ></img>
            <button className={`d-flex align-items-center ${searchText.trim().length > 0 ? "active-search-title" : "deactive-search-title"}`}><p onClick={(e) => searchHandler()}>SEARCH</p> {searchText.trim().length > 0 && <img onClick={cancelSearchField} src={CrossIcon}/>}</button>
            <input
              value={searchText}
            // id="global-search-module"
            type="text"
            name="searchInput"
            placeholder={placeholderName}
            /* placeholder={
                type === eDetail
                ? `Search by ‘e-Detail name / ID’`
                : "Search by 'Template name / ID'"
            } */
            className="module-content-search-input"
            onChange={(e) => searchfieldsHandler(e, "searchInput")}
            autoComplete="off"
            onKeyDown={(e) => {
                if(e.key === "Enter"){
                    searchHandler()
                }
            }}            
             onKeyPress={(e) => handleEnterKeypress(e)}
            />
      </div>
    )
}

export const SearchTextFieldTemplate = ({searchTextTemplate,onChangeText, removeText, onSearch, setSearchTextTemplate }) => {
    // const {
    // } = props;
    const [customPlaceholder, setCustomPlaceholder] = useState(true);

    const handleCustomPlaceholder = () => {
        // setCustomPlaceholder(false);
    }
    
    return (
        <div className="d-flex g-0 module-content-search-field">
            <img
            alt="search"
            src={LibrarySearchIcon}
            className={"module-content-search-icon"}
            ></img>
            <button className={`d-flex align-items-center ${searchTextTemplate.trim().length > 0 ? "active-search-title" : "deactive-search-title"}`}><p onClick={(e) => onSearch(e, 'click')}>SEARCH</p> {searchTextTemplate.trim().length > 0 && <img onClick={ removeText} src={CrossIcon}/>}</button>
            <input
              value={searchTextTemplate}
            // id="global-search-module"
            type="text"
            name="searchInput"
            placeholder="Search by ‘Template Name / ID’"
            /* placeholder={
                type === eDetail
                ? `Search by ‘e-Detail name / ID’`
                : "Search by 'Template name / ID'"
            } */
            className="module-content-search-input"
            onChange={(e) => onChangeText(e, "searchInput")}
            autoComplete="off"
            //   onKeyDown={handleOnEnter}
            // autoFocus
            
             onKeyDown={(e) => onSearch(e, 'key')}
            />
      </div>
    )
}